export const CLASS_NAMES = {
  container: 'flex flex-col',
  name: 'text-style-h-em text-neutral-700 md:text-style-f-em',
  address: 'text-style-h text-neutral-600 md:text-style-g',
  contactWrapper: 'flex flex-row flex-wrap',
  email: 'text-style-h text-neutral-600 md:text-style-g break-all',
  spacer: 'text-style-h text-neutral-400 mx-2',
  phoneNumber: 'text-style-h text-neutral-600 md:text-style-g break-all',
};
